//const serverUrl = "http://localhost:8081";
//const serverUrl = "http://localhost:8081/shifaa-api-1.7.0";
const serverUrl = "https://shifaa-api.barmajiyat.net";
const defaultCountryCode = "961";

export {
  serverUrl,
  defaultCountryCode,
}